import 'vuetify/src/styles/generic/_reset.scss'
import Vuetify from './vuetify-plugin-without-reset-scss'

export default Vuetify
